import { ApplicationContext, Language } from '@breathelife/types';

import {
  EvaluationVisitor,
  ExpandedQuestionnaire,
  IAnswerResolver,
  RenderingFieldOption,
  TransformEvaluationVisitorAdapter,
  TransitionField,
  VisitNodeFunction,
} from '@zinnia/form-engine-sdk';
import _ from 'lodash';

export function populateApplicationContextSelectOptions(
  questionnaire: ExpandedQuestionnaire,
  applicationContext: ApplicationContext,
  answersResolver: IAnswerResolver,
  language: Language,
): ExpandedQuestionnaire {
  const createApplicationContextSelectOptionsVisitor = createApplicationContextSelectOption(
    applicationContext,
    language,
  );

  const visitorAdapter = new TransformEvaluationVisitorAdapter(
    answersResolver,
    createApplicationContextSelectOptionsVisitor,
  );
  visitorAdapter.visitQuestionnaire(questionnaire);

  return questionnaire;
}

function createApplicationContextSelectOption(
  applicationContext: ApplicationContext,
  language: Language,
): EvaluationVisitor<void, void> {
  const visitField: VisitNodeFunction<TransitionField, void> = (navigation, { node }) => {
    if (node.optionsFromApplicationContext) {
      const { tag, labelKey, valuePath } = node.optionsFromApplicationContext;

      const applicationContextData = applicationContext[tag];

      if (!applicationContextData) {
        return;
      }

      if (!Array.isArray(applicationContextData)) {
        return;
      }

      const renderingFieldOptions: RenderingFieldOption[] = applicationContextData.map((acd) => {
        return {
          id: _.get(acd, valuePath, ''),
          text: _.get(acd, labelKey[language], ''),
          disabled: node.disabled,
          iconName: node.iconName,
          info: node.info,
          metadata: node.metadata,
          title: node.title,
          visible: node.visible,
        };
      });

      node.options = renderingFieldOptions;
    }
  };

  return {
    visitDefault: (navigation) => navigation.visitChildren(),
    visitField,
    complete: () => {},
  };
}
